// extracted by mini-css-extract-plugin
export default {"calendar":"Tab_calendar__d9xh6","tabs":"Tab_tabs__uK8QX","tab1":"Tab_tab1__cb2tR"};